import React, { useState } from 'react';
import { FaCreditCard, FaLock } from 'react-icons/fa';
import { loadBalance } from '../../../services/cardService';
import api from '../../../services/api';
import { message } from 'antd';

const CardBalanceLoad = () => {
    const [cardNumber, setCardNumber] = useState('');
    const [amount, setAmount] = useState('');

    const handleLoad = async () => {
        if (!cardNumber || !amount) return;

        try {
            const res = await loadBalance({ cardNumber, amount: parseFloat(amount) });
            if (res.data?.isSuccess) {
                const txData = res.data.data;

                // Initiate payment through existing Payment controller.
                const paymentRes = await api.post('/api/payment/initiate-3d', {
                    description: txData.description,
                    amount: txData.amount,
                    currencyCode: 'TRY',
                    installmentsCount: 0,
                    paymentGroup: 'CardTopUp',
                    buyerId: 'guest',
                    callbackUrl: window.location.origin + '/api/payment/callback'
                });

                if (paymentRes.data?.isSuccess) {
                    const formHtml = paymentRes.data.data;
                    const newWindow = window.open('', '_self');
                    newWindow.document.write(formHtml);
                } else {
                    message.error('Odeme baslatilamadi: ' + paymentRes.data?.resultMessage);
                }
            } else {
                message.error(res.data?.resultMessage || 'Islem baslatilamadi.');
            }
        } catch (error) {
            console.error(error);
            message.error('Hata olustu.');
        }
    };

    return (
        <div className="booking-form balance-load-modern">
            <div className="balance-load-header">
                <div className="balance-load-title-wrap">
                    <span className="balance-load-icon">
                        <FaCreditCard />
                    </span>
                    <div>
                        <h4>Bakiye Yukleme</h4>
                        <p>Kart numarasi ve yukleme tutarini girerek odeme adimina gecin.</p>
                    </div>
                </div>
                <span className="balance-load-security">
                    <FaLock />
                    Guvenli odeme
                </span>
            </div>

            <div className="balance-load-fields">
                <div className="form-group">
                    <label>Kart Numarasi</label>
                    <input
                        className="form-input"
                        value={cardNumber}
                        onChange={(e) => setCardNumber(e.target.value)}
                        placeholder="Kart uzerindeki numara"
                    />
                </div>

                <div className="form-group">
                    <label>Yuklenecek Tutar (TL)</label>
                    <input
                        className="form-input"
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="0.00"
                    />
                    <small className="balance-load-helper">Minimum tutar isletme kurallarina gore belirlenir.</small>
                </div>
            </div>

            <button className="submit-button balance-load-submit" onClick={handleLoad}>
                Odemeye Gec
            </button>
        </div>
    );
};

export default CardBalanceLoad;
